import Home from '../pages/Home';

export default [
  {
    key: 'root',
    path: '/',
    exact: true,
    component: Home,
    title: 'campaign',
  },
]
